module.exports = "/images/bank_broker.png?ac7106f7a9c20315dc1bc80b785b9433";